import { Component, OnInit, OnDestroy, ViewChild, ElementRef,TemplateRef ,Input} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { ApifirstService } from 'src/app/service/apifirst.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {Draggablemodal1Component} from "../draggablemodal1/draggablemodal1.component";
import * as environmentUrl from 'src/environments/environment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-check-existing-session',
  templateUrl: './check-existing-session.component.html',
  styleUrls: ['./check-existing-session.component.scss']
})
export class CheckExistingSessionComponent implements OnInit, OnDestroy {
  ptsUrl = environmentUrl.environment.ptsUrl
  public sessionData: any;
  private sessionSub: Subscription;

  // Local variables for ownership update
  private dealerCode: any;
  private userName:any;
  private userId: any;
  private webPages: any;
  private   vin: any;
    repairData : any;
    isButtonEnabled : boolean = true;
  // Route mapping (replicated from vehicle-sessions)
  public pageList: any = {
    "diagnosisSymptomSelectionWebPage": "symptoms",
    "networkTestWebPage": "networkTest",
    "symptomEvaluationUserWaitTask": "info",
    "symptomEvaluationUserWaitTaskComplete": "info",
    "manualDiagnosisInstructionsWebPage": "identifyFailure",
    "warrantyDealerCodeSelectionPage": "warrantyDealerCode",
    "repairAndPostRepairEvaluationUserWaitTaskComplete": "repair",
    "repairValidationCodeDisplayWebPage": "repair",
    "repairCandidateSelectionWebPage": "repairProcedures",
    "postRepairCandidateSelectionWebPage": "postrepairProcedures",
    "purchaseRepairWebPage": "view",
    "purchasePostRepairWebPage": "view",
    "purchaseDiagnosticWebPage": "diagnostic-view",
    "rvcWebPage": "identifyFailure"
  };
  isSameUser: boolean;
 @ViewChild('mobileVanModal') mobileVanModal: ElementRef<any>;
 @ViewChild('noRVCMsgDesc') noRVCMsgDesc: ElementRef<any>;
   @ViewChild('content') contentTemplateRef: TemplateRef<any>;

  isFDRSConnected: any;

  constructor(
    public activeModal: NgbActiveModal,
    private service: ApifirstService,
    private router: Router,private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    // 1. Get the session data from the Startup component's broadcast
    this.sessionSub = this.service.existingSessionData.subscribe(data => {
      if (data) {
        this.sessionData = data;
      }
    });
    this.service.isFDRSConnection.subscribe((data) => {
      this.isFDRSConnected = data;
    })

    // 2. Get current user details for the updateDealerCode call
    this.service.tokenObj.subscribe((token: any) => {
      if (token) {
        this.dealerCode = token.dealerCode;
        this.userId = localStorage.getItem('userId');
        this.userName=token.username;
        this.vin=token.vin;
      }
    });

    // 3. Get webpage mapping for navigation
    this.service.getWebpageMapping().subscribe(map => {
      this.webPages = map;
    });
  }

  continueWithExistingSession(content:any) {
    if (!this.sessionData) return;

    if (this.sessionData.sessionCount > 1) {
      // --- CASE: MULTIPLE SESSIONS ---
      // Navigate to the main resume session page (the table list)
      this.router.navigate(['/vehicleSessions']);
      this.activeModal.close();

    } else if (this.sessionData.sessionCount === 1) {
      // --- CASE: SINGLE SESSION ---
      // Automatically perform the resume and ownership transfer
          const session = this.sessionData.sessions[0];
          // console.log()
          console.log("createdBy",this.sessionData.sessions[0].createdBy);
           console.log("dealercode",this.sessionData.sessions[0].dealerCode);
           console.log("userName",this.userName)
           console.log("deaLERcODE",this.dealerCode)
          if(this.sessionData.sessions[0].createdBy === this.userName &&  this.sessionData.sessions[0].dealerCode===this.dealerCode) {
             this.isSameUser = true;
            console.log("isSameUser", this.isSameUser)
          }

          const restoreReq = {
            "vin": this.vin,
            "createdTimeStamp": session.createdTimestamp
          };

          this.service.resumeSession(restoreReq).subscribe({
        next: (res) => {
          console.log("print res", res);
          console.log("print res1", res);
          if (this.isSameUser) {
            const mobileVanModalRef = this.modalService.open(this.mobileVanModal, {
              windowClass: 'mobilevan-dialog-window',
              centered: true
            });

         // ✅ This is what actually fixes the aria-hidden issue
Promise.all([
  mobileVanModalRef.result,
  mobileVanModalRef.hidden.pipe(take(1)).toPromise()
])
.then(([keepMobile, hiddenEvent]) => {
  // mobileVanModal is fully hidden and removed from DOM
  // Only NOW proceed with next actions
  if (keepMobile) {
    this.updateOwnershipAndNavigate(res, this.contentTemplateRef);
  } else {
    this.handleResumeNavigation(res, this.contentTemplateRef);
  }
})
.catch((reason) => {
  this.activeModal.dismiss('Mobile van modal dismissed');
});

          } else {
            this.updateOwnershipAndNavigate(res, this.contentTemplateRef); // Pass content here
          }
        },
        error: (err) => {
          console.error('Restore failed', err);
          this.activeModal.dismiss('Restore failed');
        }
      });
    }
  }

private updateOwnershipAndNavigate(res: any,content:any) {
  const updatePayload = {
    "sessionId": String(res.sessionId),
    "updatedDealerCode": this.dealerCode,
    "currentUserId": localStorage.getItem("userId"),
    "updatedUsername": this.userName,
    "updatedTimeStamp": new Date().toISOString(),
    "isMobileVehicle": false,
    "alreadyResumedByDealer": true
  };

  this.service.updateDealerCode(updatePayload).subscribe({
    next: (updateRes) => {
         this.activeModal.close();
      console.log('Dealer code updated to:', this.dealerCode);
       this.modalService.dismissAll();
      this.handleResumeNavigation(res,this.contentTemplateRef);
    },
    error: (err) => {
      console.error('Update dealer code failed', err);
      this.modalService.dismissAll();
    }
  });
}

  ngOnDestroy() {
    if (this.sessionSub) {
      this.sessionSub.unsubscribe();
    }
  }


  handleResumeNavigation(res: any,content:any) {

        this.service.fromResume.next(true);
        this.service.fromCapture.next(false);
        this.service.navigateSymptom.next('');
        this.service.pageData.next(res.pageData);

        // 2. Local Storage
        localStorage.setItem("sessionID", res.sessionId);
        localStorage.setItem("pageId", res.pageId);

        // 3. Mapping
        let page = this.webPages[res.pageId];
        let nextPage = this.pageList[page];
        console.log("into check-existing-194")

        console.log("Resuming to page:", page, "Route:", nextPage);

        // --- CASE BY CASE LOGIC (As per vehicle-sessions.ts) ---

        if (page === "rvcWebPage") {
            localStorage.removeItem('pausedOnRvcPage');
            localStorage.setItem('isRVCINput', 'true');
            this.service.repairQualificationData.next(res.pageData);
            this.router.navigate([nextPage]);
        }
        else if (page == "customerCommentsWebPage") {
            this.modalService.open(Draggablemodal1Component, { windowClass: "myCustomModalClass" });
        }
         else if (page == "repairValidationCodeDisplayWebPage") {
            console.log("inside repairValidationCodeDisplayWebPage")

              this.service.repairQualificationData.next(res.pageData);
              this.service.resumeRVC.next(true);
              this.service.repairQualificationData.subscribe( data =>{
                  this.repairData = data;
              })
              console.log("inrepair",this.repairData)
              if(this.repairData.rvcCode == 'No RVC' || this.repairData.rvcCode == null || this.repairData.rvcCode == 'No RVC Required' || this.repairData.rvcCode == 'RVC not required') {
                 console.log("inside ifrepairx",this.repairData)
                  this.modalService.open(this.noRVCMsgDesc, { size: 'md' })
                  this.disableButtonAfterModalOpen();
              }
              this.service.control.next(false);
              this.service.isRepairProcedure.next(false);
              this.service.isPostRepairProcedure.next(false);
              this.router.navigate(['/repair']);
          }
        else if (page == "repairAndPostRepairEvaluationUserWaitTaskComplete") {
            this.service.repairQualificationData.next(res.pageData.repairAndPostRepairDto);
            this.service.resumeRVC.next(false);
            if (res.pageData.viewButtonComplete) {
                this.service.control.next(true);
                if (res.pageData.repairGoComplete) {
                    this.service.isRepairProcedure.next(false);
                    this.service.isPostRepairProcedure.next(!res.pageData.postRepairGoComplete);
                } else {
                    this.service.isRepairProcedure.next(true);
                    this.service.isPostRepairProcedure.next(false);
                }
            } else {
                this.service.control.next(false);
                this.service.isRepairProcedure.next(false);
                this.service.isPostRepairProcedure.next(false);
            }
            this.router.navigate(['/repair']);
        }
        else if (page == "purchaseRepairWebPage" || page == "purchasePostRepairWebPage") {
            this.service.repairQualificationData.next(res.pageData.repairQualificationPageData);
            if (res.pageData.procRefDetails) {
			      let candidateKind: string = res.pageData.selectedCandidate.kind;
                  let candidateId: string = res.pageData.selectedCandidate.procRef.procUidRef;
                  let gIdArray: any = [];
                   for (let candidate of res.pageData.candidates) {
                    if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                          if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Tested';
                          } else if (candidate.result.state == 'Error') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Error';
                          } else if (candidate.result.state == 'abort') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Aborted';
                          } else {
                              candidate.result.state = 'Untested';
                          }
                      }else if (candidate.result.state == 'pass') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Viewed';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else {
                          candidate.result.state = 'Unread';
                      }
                   }
                    if (page == "purchaseRepairWebPage") {
                      let repairObj = {
                          'id': candidateId,
                          'screen': 'repair',
                          'kind': candidateKind
                      }
                      this.service.storeGidRepair.next(gIdArray);
                      this.service.repairObj.next(res.pageData.candidates);
                      this.service.navigatetoPreviousScreen.next(repairObj);
                      this.router.navigate(['/repairProcedures']);
                  }else if (page == "purchasePostRepairWebPage") {
                      let postRepairObj = {
                          'id': candidateId,
                          'screen': 'postRepair',
                          'kind': candidateKind
                      }
                      this.service.storeGidPostRepair.next(gIdArray);
                      this.service.postRepairObj.next(res.pageData.candidates);
                      this.service.navigatetoPreviousScreen.next(postRepairObj);
                  }

                   if (candidateKind == "PINPOINT-CANDIDATE" || candidateKind == "GENERAL-INFORMATION-CANDIDATE" || candidateKind == "REPAIR-INFO-CANDIDATE") {
                      this.router.navigate(['/view']);
                  }
                  else if (candidateKind == "ETIS-CANDIDATE") {
                      const path = this.ptsUrl + "transport/?link=700&params=" + this.vin + "&uid=" + res.pageData.procRefDetails.uid + "&procuid=" + res.pageData.procRefDetails.procuid;  // check vinnumber and ptsUrl
                      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                      this.router.navigate(['/view']);
                  }else if (candidateKind == "TSB-CANDIDATE") {
                      var procUidref = res.pageData.procRefDetails.procuid;
                      procUidref = procUidref.substring(4);
                      procUidref = procUidref.replace("/", "-")
                      if (procUidref == "68-2013") {
                          procUidref = "068-2013"
                      }
                      const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
                      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                      this.router.navigate(['/view'])
                  }else if (candidateKind == "OTX-CANDIDATE" || candidateKind == 'OTX-SERVFUNC-CANDIDATE' || candidateKind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (this.isFDRSConnected) {                 // check this value
                          if (page == "purchaseRepairWebPage") {
                              let selectedRecord = [{
                                  "rating": res.pageData.selectedCandidate.rating,
                                  "procedure": res.pageData.selectedCandidate.title,
                                  "state": 'Untested'
                              }]
                              this.service.candidateId.next(res.pageData.selectedCandidate.procRef.procUidRef);
                              this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                              this.service.navigatePreviousScreen.next('repairProcedure');
                              this.router.navigate(['/repairProcedures'])
                          }
                          else if (page == "purchasePostRepairWebPage") {
                              let selectedRecord = [{
                                  "rating": res.pageData.selectedCandidate.rating,
                                  "procedure": res.pageData.selectedCandidate.title,
                                  "state": 'Untested'
                              }]
                              this.service.candidateId.next(res.pageData.selectedCandidate.procRef.procUidRef);
                              this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                              this.service.navigatePreviousScreen.next('postRepairProcedure');
                          }
                          this.router.navigateByUrl('otxCandidate');
                      }
                      else {
                          this.modalService.open(content, { centered: true })
                      }
                  }
            } else {
                let gIdArray: any = [];
                  for (let candidate of res.pageData.candidates) {
                      if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                          if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Tested';
                          } else if (candidate.result.state == 'Error') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Error';
                          } else if (candidate.result.state == 'abort') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Aborted';
                          } else {
                              candidate.result.state = 'Untested';
                          }
                      } else if (candidate.result.state == 'pass') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Viewed';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else {
                          candidate.result.state = 'Unread';
                      }
                  }
                   if (page == "repairCandidateSelectionWebPage") {
                      this.service.storeGidRepair.next(gIdArray);
                      this.service.repairObj.next(res.pageData.candidates);
                      this.router.navigate(['/repairProcedures']);
                  }
                  else if (page == "postRepairCandidateSelectionWebPage") {
                      this.service.storeGidPostRepair.next(gIdArray);
                      this.service.postRepairObj.next(res.pageData.candidates);
                      this.router.navigate(['/postrepairProcedures']);
                  }
            }

        }
        else if (page == "repairCandidateSelectionWebPage" || page == "postRepairCandidateSelectionWebPage") {
            this.service.repairQualificationData.next(res.pageData.repairQualificationPageData);
            let gIdArray: any = [];
            for (let candidate of res.pageData.candidates) {
                  if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Tested';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else if (candidate.result.state == 'abort') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Aborted';
                      } else {
                          candidate.result.state = 'Untested';
                      }
                  } else if (candidate.result.state == 'pass') {
                      gIdArray.push(candidate.procRef.procUidRef);
                      candidate.result.state = 'Viewed';
                  } else if (candidate.result.state == 'Error') {
                      gIdArray.push(candidate.procRef.procUidRef);
                      candidate.result.state = 'Error';
                  } else {
                      candidate.result.state = 'Unread';
                  }
        }
        if (page == "repairCandidateSelectionWebPage") {
                  this.service.storeGidRepair.next(gIdArray);
                  this.service.repairObj.next(res.pageData.candidates);
              }
              else if (page == "postRepairCandidateSelectionWebPage") {
                  this.service.storeGidPostRepair.next(gIdArray);
                  this.service.postRepairObj.next(res.pageData.candidates);
              }
              this.router.navigateByUrl(nextPage);
        }
          else if (page == "purchaseDiagnosticWebPage") {
            console.log("purchaseDiagnosticWebPage")
            let candidateData: any;
              candidateData = res.pageData.candidates;
              console.log("purchaseDiagnosticWebPage5")
              for (let obj of candidateData) {
                  obj.isCheckBoxSelected = false;
                  obj.isCheckBoxDisable = false;
                  if (obj.state == "skipped") {
                      obj.state = 'Skipped';
                      obj.isCheckBoxSelected = true
                      obj.isDisableTestViewBtns = true;
                  } else if (obj.state == "fail") {
                      obj.state = 'fail - Fault found';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.state == 'Error') {
                      obj.state = 'Error';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.state == 'abort') {
                      obj.state = 'Aborted';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.kind == 'OTX-CANDIDATE' || obj.kind == 'OTX-SERVFUNC-CANDIDATE' || obj.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Pass - no Fault';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'Untested'
                      }
                  } else if (obj.kind == 'TSB-CANDIDATE' || obj.kind == 'GENERAL-INFORMATION-CANDIDATE'
                      || obj.kind == 'REPAIR-INFO-CANDIDATE' || obj.kind == 'ETIS-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Pass - no Fault';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'Unread'
                      }
                  } else if (obj.kind == 'PINPOINT-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Viewed';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'View';
                      }
                  }
              }
              this.service.getSelectedDiagProcdureId.next(res.pageData.selectedCandidate.id);
              this.service.otxStateChangeObj.next(candidateData);
              this.service.fromCapture.next(true)
              this.service.navigateSymptom.next('sym')
              let tempSymptomChildId = [0]
              this.service.candidateId.next(res.pageData.selectedCandidate.id);
              this.service.candidateKind.next(res.pageData.selectedCandidate.kind);
              this.service.candidateProcUid.next(res.pageData.selectedCandidate.procRef.procUidRef);
              console.log("purchaseDiagnosticWebPage6")
              if (res.pageData.selectedCandidate.kind == "PINPOINT-CANDIDATE"
                  || res.pageData.selectedCandidate.kind == "GENERAL-INFORMATION-CANDIDATE"
                  || res.pageData.selectedCandidate.kind == "REPAIR-INFO-CANDIDATE") {
                  console.log("diagnostic")
                  this.router.navigateByUrl('diagnostic-view');
              }
               else if (res.pageData.selectedCandidate.kind == "TSB-CANDIDATE") {
                  var procUidref = res.pageData.procRefDetails.procuid;
                  procUidref = procUidref.substring(4);
                  procUidref = procUidref.replace("/", "-")
                  if (procUidref == "68-2013") {
                      procUidref = "068-2013"
                  }
                  const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
                  window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                  console.log("diagnostic")
                  this.router.navigateByUrl('diagnostic-view')
              }
               else if (res.pageData.selectedCandidate.kind == "OTX-CANDIDATE"
                  || res.pageData.selectedCandidate.kind == 'OTX-SERVFUNC-CANDIDATE'
                  || res.pageData.selectedCandidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                  if (this.isFDRSConnected) {
                    console.log("FDRS  Conected")
                      let selectedRecord = [{
                          "rating": res.pageData.selectedCandidate.rating,
                          "procedure": res.pageData.selectedCandidate.kind,
                          "state": 'Untested'
                      }]
                      this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                      this.service.navigatePreviousScreen.next('diagnosticProcedure');
                      this.router.navigateByUrl('otxCandidate');
                  }
                  else {
                    console.log("FDRS not Conected")
                     this.activeModal.close();
                      this.modalService.open(content, { centered: true })
                  }
                }

        }
        else if (page == "symptomEvaluationUserWaitTaskComplete" || page == "symptomEvaluationUserWaitTask") {
              this.service.fromCapture.next(true);
              this.service.navigateSymptom.next('sym');
              this.service.diagnosticViewFaultFound.next({
                  "status": '',
                  "isFound": false,
                  "faultString": ''
              });
              this.router.navigateByUrl(nextPage);
        }
        else if (page == "diagnosisSymptomSelectionWebPage") {
              this.service.fromCapture.next(true)
              this.service.navigateSymptom.next('sym')
              let tempSymptomChildId = [0]
              this.service.ParentsymptomSubject.next(res.pageData.parentchildsymptomsidList)
              this.service.listsymptomSubject.next(res.pageData.symptomidList)
              this.service.symptomSubject.next(res.pageData.selectedSymptomCount)
              this.service.tempSymptomSubject.next(tempSymptomChildId)
              this.router.navigateByUrl(nextPage)
        }
        else if (page == "manualDiagnosisInstructionsWebPage") {
              this.service.sId.next(res.sessionId)
              this.router.navigateByUrl(nextPage)
        }
        else {
             console.log("other page")
              this.router.navigateByUrl(nextPage);
        }

    }
    disableButtonAfterModalOpen() {
    setTimeout(() => {
      this.isButtonEnabled = false;
    }, 3000);
  }
}
